export default "__VITE_ASSET__dc146376__"